const ASSESSMENT_SOURCE_MY_TESTS = 'My Tests';
export const sourceIsMyTests = (source?: string): boolean => (
  source?.toUpperCase() === ASSESSMENT_SOURCE_MY_TESTS.toUpperCase()
);
